import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SharedModule } from 'ag-common-svc/shared/shared.module';
import {
  DietaryConsiderationTypeSelectBoxModule,
  GenderSelectBoxModule,
  ModalWindowModule,
  TShortSizeSelectBoxModule,
} from 'ag-common-svc/lib/components';
import {
  RelationshipTypeSelectBoxModule,
} from '../../../relationship-type-select-box/relationship-type-select-box.module';
import { StateSelectBoxModule } from '../../../state-select-box/state-select-box.module';
import { AssociationsComponent } from './associations.component';
import { DietaryConsiderationsFormModule } from '../dietary-considerations-form/dietary-considerations-form.module';
import {
  TShirtSizesFormModuleDeprecated,
} from '../../../t-shirt-sizes-form-deprecated/t-shirt-sizes-form-module-deprecated.module';
import { FlightPreferenceFormModule } from '../flight-preference-form/flight-preference-form.module';
import { DxTabPanelModule, DxValidatorModule } from 'devextreme-angular';
import {
  AssociationMainInfoFormComponent,
} from './components/association-main-info-form/association-main-info-form.component';
import {
  AssociationFunStuffSizesFormComponent,
} from './components/association-fun-stuff-sizes-form/association-fun-stuff-sizes-form.component';
import {
  AssociationAddressFormComponent,
} from './components/association-address-form/association-address-form.component';
import {
  AddressAutocompleteModule,
} from 'ag-common-svc/lib/components/address-autocomplete/address-autocomplete.module';
import { TShirtSizesFormModule } from 'ag-common-svc/lib/components/t-shirt-sizes-form/t-shirt-sizes-form.module';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    ModalWindowModule,
    StateSelectBoxModule,
    TShortSizeSelectBoxModule,
    DietaryConsiderationTypeSelectBoxModule,
    GenderSelectBoxModule,
    RelationshipTypeSelectBoxModule,
    DietaryConsiderationsFormModule,
    TShirtSizesFormModuleDeprecated,
    FlightPreferenceFormModule,
    DxTabPanelModule,
    DxValidatorModule,
    TShirtSizesFormModule,
    AddressAutocompleteModule,
  ],
  declarations: [
    AssociationsComponent,
    AssociationMainInfoFormComponent,
    AssociationFunStuffSizesFormComponent,
    AssociationAddressFormComponent,
  ],
  exports: [AssociationsComponent],
})
export class AssociationsModule {}
